import { render } from "./NativeInput.vue?vue&type=template&id=126b162c&ts=true"
import script from "./NativeInput.vue?vue&type=script&lang=ts"
export * from "./NativeInput.vue?vue&type=script&lang=ts"

import "./NativeInput.vue?vue&type=style&index=0&id=126b162c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
